import { render } from "./EditSection.vue?vue&type=template&id=9657c8fa"
import script from "./EditSection.vue?vue&type=script&lang=js"
export * from "./EditSection.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/4schemplus/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__